export default function TrustBar() {
  const indicators = [
    { icon: 'ri-award-line', text: 'Licensed in All 50 States' },
    { icon: 'ri-time-line', text: '24/7 Emergency Service' },
    { icon: 'ri-file-text-line', text: 'Electronic Filing Certified' },
    { icon: 'ri-map-pin-line', text: 'GPS Tracking Available' },
    { icon: 'ri-lock-line', text: 'Secure Client Portal' },
  ];

  return (
    <section className="bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-5 gap-8">
          {indicators.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-3xl text-[#1a2b4a]`}></i>
              </div>
              <p className="text-sm font-medium text-[#1a2b4a]">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
